import type { Transition, Variants } from 'motion/react';

export const springs = {
  sheet: { type: 'spring', damping: 30, stiffness: 300 },
  snappy: { type: 'spring', stiffness: 300, damping: 20 },
  bouncy: { type: 'spring', stiffness: 400, damping: 15 },
  soft: { type: 'spring', stiffness: 150, damping: 20, mass: 0.5 },
} satisfies Record<string, Transition>;

export const durations = { fast: 0.15, base: 0.2, slow: 0.3 };

export const easeOut = [0.16, 1, 0.3, 1] as const;

export const fade: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: durations.base } },
  exit: { opacity: 0, transition: { duration: durations.fast } },
};

export const fadeUp: Variants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0, transition: { duration: durations.base, ease: easeOut } },
  exit: { opacity: 0, y: 4, transition: { duration: durations.fast } },
};

export const scaleIn: Variants = {
  initial: { opacity: 0, scale: 0.95 },
  animate: { opacity: 1, scale: 1, transition: { duration: durations.base, ease: easeOut } },
  exit: { opacity: 0, scale: 0.95, transition: { duration: durations.fast } },
};

export const pop: Variants = {
  initial: { opacity: 0, scale: 0.5 },
  animate: { opacity: 1, scale: 1, transition: springs.bouncy },
  exit: { opacity: 0, scale: 0.5, transition: { duration: durations.fast } },
};

export const slideX: Variants = {
  initial: (direction: number) => ({ opacity: 0, x: direction * 40 }),
  animate: { opacity: 1, x: 0, transition: { duration: durations.slow, ease: easeOut } },
  exit: (direction: number) => ({ opacity: 0, x: direction * -40, transition: { duration: durations.fast } }),
};

export const cardPresence: Variants = {
  initial: { opacity: 0, scale: 0.96, height: 0, overflow: 'hidden' },
  animate: {
    opacity: 1,
    scale: 1,
    height: 'auto',
    transition: { duration: durations.base, ease: easeOut },
    transitionEnd: { overflow: 'visible' },
  },
  exit: { opacity: 0, scale: 0.96, height: 0, overflow: 'hidden', transition: { duration: durations.base } },
};

export const collapse: Variants = {
  initial: { opacity: 0, height: 0 },
  animate: { opacity: 1, height: 'auto', transition: { duration: durations.base } },
  exit: { opacity: 0, height: 0, transition: { duration: durations.fast } },
};

export const slideFromTop: Variants = {
  initial: { y: '-100%', opacity: 0 },
  animate: { y: 0, opacity: 1, transition: springs.sheet },
  exit: { y: '-100%', opacity: 0, transition: { duration: durations.base } },
};

export const slideFromBottom: Variants = {
  initial: { y: '120%', opacity: 0 },
  animate: { y: 0, opacity: 1, transition: springs.sheet },
  exit: { y: '120%', opacity: 0, transition: { duration: durations.base } },
};

export const listStagger: Variants = {
  initial: {},
  animate: { transition: { staggerChildren: 0.04 } },
};
